export function getFilenameExtension(filename) {
  if (typeof filename === 'string') {
    const PARTS = filename.split('.');
    // If there is no '.' or there is only one and it is the first character, we have no file extension
    if (PARTS.length === 1 || (PARTS[0] === '' && PARTS.length === 2)) {
      return '';
    }
    return PARTS.pop();
  } else {
    return '';
  }
}

export function concatFilename(filename, extension) {
  return `${filename}.${extension}`;
}

export function isDisplayable(filename) {
  filename = filename.toLowerCase();
  return !(
    filename.endsWith('.pdf') ||
    filename.endsWith('.tif') ||
    filename.endsWith('.tiff')
  );
}
